import { t } from 'i18next';
import { Option } from '../SelectField';

export const healthComfortOptions: Option[] = [
  {
    label: t('Saúde'),
    value: 'health',
    iconName: 'ActivityIcon',
  },
  {
    label: t('confortoTermico'),
    value: 'thermalComfort',
    iconName: 'Thermometer2Icon',
  },
];

export const statusHealthOptions: Option[] = [
  {
    label: t('saudaveis'),
    value: 'healthy',
    iconName: 'CheckVerified1Icon',
  },
  {
    label: t('emAlertaSemiCritico'),
    value: 'alert',
    iconName: 'AlertCircleIcon',
  },
  {
    label: t('emAlertaCritico'),
    value: 'critical',
    iconName: 'XCircle1Icon',
  },
];

export const statusComfortOptions: Option[] = [
  {
    label: t('confortaveis'),
    value: 'comfortable',
    iconName: 'Check',
  },
  {
    label: t('abaixoLimite'),
    value: 'below_limit',
    iconName: 'SnowflakeIcon',
  },
  {
    label: t('acimaLimite'),
    value: 'above_limit',
    iconName: 'WavesIcon',
  },
];
